import { makeStyles } from '@material-ui/core/styles';
import { fontColors, fontWeight, tertiaryColors } from '../../styles/variables';

export default makeStyles((theme) => ({
  clearButton: {
    padding: '0.29rem',
    visibility: 'hidden',
  },
  visibleButton: {
    visibility: 'visible',
  },
  icon: {
    color: fontColors.body,
    opacity: 0.5,
  },
  input: {
    cursor: 'pointer',
    '& input': {
      cursor: 'pointer',
    },
  },
  placeholder: {
    color: fontColors.subBody,
  },
  dayWrapper: {
    paddingRight: '0.72rem',
    marginTop: '0.36rem',
  },
  endDateWrapper: {
    marginRight: '0.72rem',
    marginTop: '0.36rem',
  },
  endDateWeekWrapper: {
    paddingRight: 0,
    marginRight: 0,
  },
  day: {
    width: 30,
    height: 30,
    margin: 0,
    padding: 0,
    fontSize: theme.typography.caption.fontSize,
    color: fontColors.subBody,
    '&:hover': {
      fontWeight: fontWeight.bold,
      border: '1px solid',
      borderColor: theme.palette.primary.main,
      color: fontColors.header,
    },
  },
  nonCurrentMonthDay: {
    visibility: 'hidden',
  },
  highlight: {
    background: tertiaryColors.mediumGrey,
  },
  highlightDay: {
    borderRadius: '50%',
    background: theme.palette.primary.main,
    '& p': {
      color: theme.palette.common.white,
    },
  },
  firstHighlight: {
    background: tertiaryColors.mediumGrey,
    borderRadius: '50% 0 0 50%',
  },
  endHighlight: {
    background: tertiaryColors.mediumGrey,
    borderRadius: '0 50% 50% 0',
  },
}));
